"use client";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MAX_CHARS } from "@/lib/config";

interface TextInputFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export function TextInputField({ value, onChange }: TextInputFieldProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label
          htmlFor="konfigurator-text"
          className="text-xs font-semibold tracking-wide text-muted-foreground uppercase"
        >
          Dein Text
        </Label>
        <span className="text-xs text-muted-foreground tabular-nums">
          {value.length} / {MAX_CHARS} Zeichen
        </span>
      </div>
      <Input
        id="konfigurator-text"
        value={value}
        maxLength={MAX_CHARS}
        placeholder="z. B. Alpine Customs"
        onChange={(e) => onChange(e.target.value)}
      />
      <p className="text-xs text-muted-foreground">Leerzeichen zählen mit.</p>
    </div>
  );
}
